
import { defineComponent, PropType, computed } from '@vue/composition-api';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: String,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    options: {
      type: Array as PropType<Array<{
        name: string;
        value: string;
        options: Array<{
          name: string;
          color?: string;
        }>;
      }>>,
      required: true,
    },
  },
  setup(props) {
    const showSelect = computed(() => !props.value || props.options.length > 1);
    const filterOptions = computed(() => {
      const selected = props.options.find((d) => d.value === props.value);
      return selected ? selected.options : [];
    });
    const hasOptions = computed(() => {
      if (props.options.length === 0) {
        return false;
      }
      if (props.options.length === 1 && !props.options[0].value) {
        return false;
      }
      return true;
    });
    return {
      showSelect,
      filterOptions,
      hasOptions,
    };
  },
});
